import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ChatListItem, IconInput, SVG } from "ui";
import useWindowSize from "utils/hooks/useWindowSize";

import "assets/css/chat.css";

const ChatList = () => {
    const [windowWidth] = useWindowSize();
    const [filter, setFilter] = useState("");
    return (
        <FeedLayout pageTitle="">
            <div className="profile-followers-div">
                <div
                    className={`d-flex${windowWidth < 567 ? "text=center flex-col flex-a-start" : " flex-j-between flex-a-center"} gap-10 w-full mb-30 mt-20`}
                >
                    <div
                        className={`d-flex ${windowWidth < 567 ? "mb-20 flex-j-between w-full" : "flex-j-start"} flex-a-center gap-10`}
                    >
                        <div>
                            <Link to="/">
                                <SVG svg="chevron-left" size={24} />
                            </Link>
                        </div>
                        <h1 className="fw-700 fs-12em">Messages</h1>
                        <div></div>
                    </div>

                    <div className={windowWidth < 567 ? " w-full" : ""}>
                        <IconInput
                            value={filter}
                            handleChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => setFilter(e.target.value)}
                            rounded
                            style={{ marginBottom: 0 }}
                        />
                    </div>
                </div>

                <div className="profile-followers-card card mt-20 overflow-y-auto chat-list-items-card">
                    <ChatListItem />
                    <ChatListItem isOnline={false} />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem isOnline={false} />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                    <ChatListItem />
                </div>
            </div>
        </FeedLayout>
    );
};

export default ChatList;
